<template>
  <el-drawer
    v-bind="$attrs"
    ref="drawer"
    :style="handleHeightAndBottom"
    :visible.sync="visible"
    :append-to-body="appendToBody"
    :title="title"
    class="cube-drawer__container"
    :class="center ? 'cube-drawer__center' : ''"
    :wrapper-closable="wrapperClosable"
    :modal="modal"
    :with-header="withHeader"
    :direction="direction"
    :show-close="showClose"
    v-on="$listeners"
  >
    <template v-if="!title && withHeader" slot="title">
      <span>
        <slot name="title" >标题</slot>
      </span>
    </template>
    <template slot="default">
      <div class="cube-drawer__body">
        <div :class="['cube-drawer__content',withHeader?'':'without-header']">
          <slot name="default" ></slot>
        </div>
        <div class="cube-drawer__footer">
          <slot name="footer" ></slot>
        </div>
      </div>
    </template>
  </el-drawer>
</template>
<script>
import '../../../../lib/styles/components/Drawer.scss'
export default {
  name: 'Drawer',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    },
    center: {
      type: Boolean,
      default: false
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    height: {
      type: [Number, String],
      default: '100%'
    },
    bottom: {
      type: [Number, String],
      default: 0
    },
    direction: {
      type: String,
      default: 'rtl'
    },
    showSideButton: {
      type: Boolean,
      default: false
    },
    sideButtonText: {
      type: String,
      default: '切换抽屉按钮'
    },
    wrapperClosable: {
      type: Boolean,
      default: true
    },
    modal: {
      type: Boolean,
      default: true
    },
    withHeader: {
      type: Boolean,
      default: true
    },
    showSideBadge: {
      type: Boolean,
      default: false
    },
    sideBadgeValue: {
      type: [Number, String],
      default: 0
    },
    showClose: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      Random: null
    }
  },
  computed: {
    handleHeight() {
      return `height:${this.height}${this.heightUnit}`
    },
    handleBottom() {
      return `top:${this.getBottom}`
    },
    getBottom() {
      return `calc(100vh - ${this.height}${this.heightUnit} - ${this.bottom}${this.bottomUnit})`
    },
    handleHeightAndBottom() {
      return `${this.handleHeight};${this.handleBottom}`
    },
    isDir() {
      const d = this.direction
      return d === 'ltr' || d === 'rtl'
    },
    heightUnit() {
      return typeof this.height === 'number' ? 'px' : this.height.endsWith('%') ? '' : 'px'
    },
    bottomUnit() {
      return typeof this.bottom === 'number' ? 'px' : this.bottom.endsWith('%') ? '' : 'px'
    },
    handleBadgeNum() {
      const v = this.sideBadgeValue
      return Number(v) > 999 ? '999+' : v
    },
    enableSide() {
      return this.showSideButton && this.isDir
    }
  },
  watch: {
    visible(value) {
      const that = this
      if (value) {
        if (this.modal && this.wrapperClosable && this.enableSide) {
          setTimeout(() => {
            const v = document.querySelector('.v-modal')
            v.addEventListener('click', () => {
              that.$emit('update:visible', !this.visible)
            })
          }, 100)
        }
        try {
          window.collectEvent('drawer_show', {
            dialog_name: that.title
          })
        } catch (e) {
          console.log(e)
        }
      }
      if (this.enableSide) {
        this.$nextTick(() => {
          this.moveEl(value)
        })
      }
    },
    handleBadgeNum(nv) {
      const dom = `.cube-drawer-side-btn .random-${this.Random}`
      console.log(document.querySelector(dom))
      Array.from(document.querySelectorAll(dom)).forEach(item => {
        item.innerHTML = nv
      })
    }
  },
  mounted() {
    this.Random = Math.floor(Math.random() * 1000)
    if (this.enableSide) {
      this.createEl()
    }
  },

  destroyed() {
    if (this.enableSide) {
      const mbtn = document.querySelector('#modal-btn' + this.Random)
      const sbtn = document.querySelector('#side-btn' + this.Random)
      mbtn && mbtn.remove()
      sbtn && sbtn.remove()
    }
  },
  methods: {
    moveEl(value) {
      let width = 0
      if (value) {
        const drawer = document.querySelector('.el-drawer__open .el-drawer')
        width = drawer.clientWidth
      }
      const div1 = document.querySelector('#modal-btn' + this.Random)
      const div2 = document.querySelector('#side-btn' + this.Random)
      const w = value ? this.direction === 'rtl' ? -width + 'px' : width + 'px' : '0px'
      div1.style.transform = `translateX(${w})`
      div2.style.transform = `translateX(${w})`
    },
    createEl() {
      const drawer = '.el-drawer__wrapper'
      const body = 'body'
      const modalId = 'modal-btn' + this.Random
      const sideId = 'side-btn' + this.Random
      const modalDiv = this.createDiv(modalId)
      const sideDiv = this.createDiv(sideId)
      sideDiv.addEventListener('click', () => {
        this.$emit('update:visible', !this.visible)
      })
      const div1 = document.querySelector('#modal-btn' + this.Random)
      if (!div1) {
        document.querySelector(drawer).appendChild(modalDiv)
      }
      const div2 = document.querySelector('#side-btn' + this.Random)
      if (!div2) {
        document.querySelector(body).appendChild(sideDiv)
      }
    },
    createDiv(id) {
      const div = document.createElement('div')
      const className = 'cube-drawer-side-btn'
      div.id = id
      div.classList.add(className)
      div.innerHTML =
      `
        <span>
          ${this.sideButtonText}
        </span>
        <span>
          ${this.createSvg()}
        </span>
        ${this.showSideBadge ? this.createBadge() : ''}
      `
      div.style.top = this.getBottom
      // 判断是左侧还是右侧
      if (this.direction === 'ltr') {
        div.style.left = '0'
      } else {
        div.style.right = '0'
      }
      return div
    },
    createSvg() {
      return `<svg aria-hidden="true" class="close-icon cnd-icon"><use xlink:href="#cnd-cell-phone"></use></svg>`
    },
    createBadge() {
      return `<span class="badge random-${this.Random}">${this.handleBadgeNum}</span>`
    }
  }
}
</script>
